// extracted by mini-css-extract-plugin
export var basicSectionColumn = "BasicSectionColumn-module--basicSectionColumn--446b7";
export var basicSectionContainer = "BasicSectionColumn-module--basicSectionContainer--4d07c";
export var blockH2 = "BasicSectionColumn-module--blockH2--3aa1a";
export var body = "BasicSectionColumn-module--body--8d3cd";
export var bodyPart = "BasicSectionColumn-module--bodyPart--342c3";
export var button = "BasicSectionColumn-module--button--06f01";
export var contactSubheader = "BasicSectionColumn-module--contactSubheader--0802e";
export var divider = "BasicSectionColumn-module--divider--99f4c";
export var externalLink = "BasicSectionColumn-module--externalLink--5012b";
export var formSection = "BasicSectionColumn-module--formSection--8d481";
export var group = "BasicSectionColumn-module--group--fa03f";
export var heroGridColumn = "BasicSectionColumn-module--heroGridColumn--0bb3f";
export var imageContainer = "BasicSectionColumn-module--imageContainer--b296b";
export var internalLink = "BasicSectionColumn-module--internalLink--f08bb";
export var linkAnchor = "BasicSectionColumn-module--linkAnchor--e8a94";
export var list = "BasicSectionColumn-module--list--35761";
export var listItem = "BasicSectionColumn-module--listItem--ed5e7";
export var listItemLabel = "BasicSectionColumn-module--listItemLabel--d44b7";
export var portal = "BasicSectionColumn-module--portal--9368d";
export var textGridColumn = "BasicSectionColumn-module--textGridColumn--71d41";
export var title = "BasicSectionColumn-module--title--e541b";
export var trustpilotWidgetWrapper = "BasicSectionColumn-module--trustpilotWidgetWrapper--5ad57";
export var ulIcon = "BasicSectionColumn-module--ulIcon--a24f0";
export var ulList = "BasicSectionColumn-module--ulList--fc9d0";